import React from "react";

const ProcessContext = React.createContext({
});
ProcessContext.displayName = "ProcessContext";
export default ProcessContext;
